import React from 'react';
import { Box } from '@saviynt/design-system';

import { useInvertedLocalize } from '../../utils';
import ExternalBanner from '../Common/ExternalBanner/ExternalBanner';

import invertedMessages from './messages';

import './BeginClassification.css';

interface BeginClassificationProps {
  closeExtBanner: () => void;
}

function BeginClassification({
  closeExtBanner = () => {},
}: BeginClassificationProps) {
  const l = useInvertedLocalize(invertedMessages);

  return (
    <Box className='Ext-BeginClassification'>
      <ExternalBanner
        heading={l(
          'Secure AI agents with built-in visibility, decision attribution, audit readiness and runtime authorization.'
        )}
        subHeading={l(
          'The Saviynt Identity Platform provides continuous visibility into AI agent access and activity, governs access across the agent lifecycle, enforces Zero Standing Privilege, and verifies actions at runtime.'
        )}
        buttonText={l('Begin Identity Security for AI')}
        closeExtBanner={closeExtBanner}
        showButton
        showClose
        // TODO: Replace this, used to be Classification
        illustration='AIAgent'
      />
    </Box>
  );
}

export default BeginClassification;
